import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Card, Checkbox, Tooltip } from "antd";
import "@ant-design/compatible/assets/index.css";
import {
  ClockCircleOutlined,
  PlusOutlined,
  CheckOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "../../../../styles/helper.scss";
import * as Utilities from "../../Utilities";
import _ from "lodash";
import ENVIRONMENT from "../../../../environments";
import "../../CustomerComponents/EntityCard/EntityCard.scss";
import FileConstants from "../../../../FileConstants";

const EntityItem = (props) => {
  const {
    ele,
    selectable,
    selected,
    setSelected,
    singleSelect,
    entityType,
    store,
    setSelectedElementDetials,
    checked,
    requestStatus,
    isCheckboxStyle = false,
    searchMode = false,
    selectedRemove,
    setSelectedRemove,
    artistSearch
  } = props;
  let updateTime = Utilities.timestampToTimeSince(
    selectable ? ele.last_modified_stamp : ele.last_modified
  );
  const entity_type = entityType;
  if (updateTime.includes("h")) {
    updateTime = "Today";
  }

  const checkIfItemNotFreeOrAddedToLibrary = () => {
    return store && (ele?.price != 0 || ele?.price != "")
  };
  
  const isRedirectToStore = (!(requestStatus == 'always_allowed' || requestStatus == 'allowed') && checkIfItemNotFreeOrAddedToLibrary());

  const handleSelectClick = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((ele) => ele !== id));
    } else if (singleSelect) {
      setSelected([id]);
    } else {
      setSelected([...selected, id]);
    }
    setSelectedElementDetials(ele);
  };

  const handleRemoveClick = (id) => {
    if(selectedRemove.includes(id)) {
      setSelectedRemove(selectedRemove.filter((ele) => ele !== id));
    } else {
      setSelectedRemove([...selectedRemove, id]);
    }
  }

  const select_id = ele.id;

  const getThumbnail = () => {
    if (entity_type === "room") {
      return (
        ENVIRONMENT.getBaseURL(ele.platform) +
        ENVIRONMENT.SPACE_THUMBNAIL_URI +
        (selectable ? ele.room_id : ele.id) +
        "/" +
        ele.thumbnail.split("/")[ele.thumbnail.split("/").length - 1]
      );
    } else if (entity_type === "product") {
      return (
        ENVIRONMENT.getBaseURL(ele.platform) +
        ENVIRONMENT.THUMBNAIL_URI +
        ele.thumbnail.split("/")[ele.thumbnail.split("/").length - 1]
      );
    } else if (entity_type === "scene") {
      return (
        ENVIRONMENT.getBaseURL(ele.platform) +
        ENVIRONMENT.SCENE_THUMBNAIL_URI +
        ele.id +
        "/" +
        ele.thumbnail
      );
    } else if (entity_type === "material") {
      if (ele.status == 5 && ele.renders && ele.renders.data && ele.renders.data.thumbnail) {
        return ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.MATERIAL_FILE_URI + ele.id + '/' + encodeURIComponent(ele.renders.data.thumbnail);
      } else if (ele.material_files && ele.material_files[0] && !ele.is_scanned) {
        return ENVIRONMENT.getBaseURL(ele.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(ele.material_files[0].uid + '/' + ele.material_files[0].name);
      } else {
        return '/img/placeholder.svg';
      }
    }
  };

  const redirectToEntity = () => {
    if (searchMode) {
      if (entity_type === "room") {
        window.location.href = `/admin_rooms/${ele.room_id}`;
      } else if (entity_type === "product") {
        window.location.href = `/admin_products/${ele.id}`;
      } else if (entity_type === "material") {
        window.location.href = `/admin_materials/${ele.id}`;
      }
    } else {
    if (store) {
      window.location.href = `/store`;
    } else if (entity_type === "room") {
      window.location.href = `/rooms/${ele.id}?entity_id=${ele.id}`;
    } else if (entity_type === "product") {
      window.location.href = `/products/${ele.id}?entity_id=${ele.id}`;
    } else if (entity_type === "scene") {
      window.location.href = `/scene_renders/${ele.id}?entity_id=${ele.id}`;
    }
  }
  };

  const handleCardClick = () => {
    if (selectable && !isRedirectToStore) {
      !checked && handleSelectClick(select_id);
    } else {
      redirectToEntity();
    }
  };

  const handleCheckClick = () => {
    if (selectable && !isRedirectToStore) {
      !checked && handleSelectClick(select_id);
    }
  }

  const getEntityDimensions = () => {
    if (Array.isArray(ele.dimensions)) {
      return !!ele.dimensions.length ? ele.dimensions.join(" x ") : "N/A";
    } else if (ele.dimensions) {
      return `D${Math.trunc(ele.dimensions.depth)}  x  W${Math.trunc(
        ele.dimensions.width
      )}  x H${Math.trunc(ele.dimensions.height)}`;
    } else {
      return "N/A";
    }
  };

  const handleArtistDownloadClick = () => {
    if(entity_type === "material") {
        let link = ENVIRONMENT.getBaseURL(ele.platform) + "materials/" + ele.id + "/" + ele.id + ".zip";
        window.open(link, '_blank');
    }
  }

  const AddIconCheck = () => {
    return (
      <div>
            {checked ? (
              <CheckOutlined
                title="Added To Scene Already"
                className="group-settings plus-icon"
              />
            ) : selected?.includes(select_id) ? (
              <CheckOutlined
                title="Added To Scene"
                className="group-settings plus-icon card-button-checked"
                onClick={() => handleCardClick()}
              />
            ) : isRedirectToStore ? (
              <a href="/store" target="_blank">
                <Tooltip
                  title={
                    <span className="manrope f-12 white">
                      Please go to store to purchase this item
                    </span>
                  }
                >
                  <img
                    src="/img/redirect-icon.svg"
                    className="item-icons plus card-icon"
                  />
                </Tooltip>
              </a>
            ) : (
              <PlusOutlined
                title="Add To Scene"
                className="group-settings plus-icon"
                onClick={() => handleCardClick()}
              />
            )}
          </div>
    )
  }

  const CheckBox = () => {
    return (
      <Checkbox
        className="group-settings"
        onChange={() => handleCardClick()}
        checked={selected?.includes(select_id)}
      ></Checkbox>
    );
  }

  return (
    <Card
      bodyStyle={{ padding: "5px" }}
      className={`entity-card ${isRedirectToStore ? `product-hover` : ``}`}
      bordered={false}
      data-tut="reactour__approved_scene"
      style={{ width: "94%" }}
      onClick={() => {
        if (artistSearch) return handleArtistDownloadClick();
        if (searchMode) return redirectToEntity();
        return handleCardClick();
      }}
    >
      <div className="stacked-project-card-inner">
        {!artistSearch && searchMode && (
          <div className="group-settings model-info left">
            {FileConstants.MODEL_STATUS_STRING[ele.status]}
          </div>
        )}
        {searchMode && ele.artist_visible && !artistSearch && (
          <div className="group-settings model-info model-info-artist">
            Visible to Artist
          </div>
        )}
        {selectable && (
          isCheckboxStyle && !searchMode
            ? <Checkbox
                className="group-settings"
                onChange={() => handleCardClick()}
                checked={selected?.includes(select_id)}
              ></Checkbox>
            : (searchMode && ele.status == 5)
              ? <div onClick={e => e.stopPropagation()}>
                  {artistSearch ? (
                    <DownloadOutlined
                      title="Download"
                      className="group-settings plus-icon"
                      onClick={handleArtistDownloadClick}
                    />
                  ) : (selected?.includes(select_id) || (!selectedRemove?.includes(select_id) && ele.artist_visible)) ? (
                    <CheckOutlined
                      title="Added To Scene"
                      className="group-settings plus-icon card-button-checked"
                      onClick={() => ele.artist_visible ? handleRemoveClick(select_id) : handleCardClick()}
                    />
                  ) : (
                    <PlusOutlined
                      title="Select Item"
                      className="group-settings plus-icon"
                      onClick={() => ele.artist_visible ? handleRemoveClick(select_id) : handleCardClick()}
                    />
                  )}
                </div>
              : <div>
                  {artistSearch ? (
                    <DownloadOutlined
                      title="Download"
                      className="group-settings plus-icon"
                      onClick={handleArtistDownloadClick}
                    />
                  ) : checked ? (
                    <CheckOutlined
                      title="Added To Scene Already"
                      className="group-settings plus-icon"
                    />
                  ) : selected?.includes(select_id) ? (
                    <CheckOutlined
                      title="Added To Scene"
                      className="group-settings plus-icon card-button-checked"
                      onClick={() => handleCardClick()}
                    />
                  ) : isRedirectToStore ? (
                    <a href="/store" target="_blank">
                      <Tooltip
                        title={
                          <span className="manrope f-12 white">
                            Please go to store to purchase this item
                          </span>
                        }
                      >
                        <img
                          src="/img/redirect-icon.svg"
                          className="item-icons plus card-icon"
                        />
                      </Tooltip>
                    </a>
                  ) :
                  ((searchMode && ele.status != 5) ?
                    <></> :
                    <PlusOutlined
                      title="Add To Scene"
                      className="group-settings plus-icon"
                      onClick={() => handleCardClick()}
                    />
                  )}
                </div>
        )}
        <div
          className="suggested-product"
          style={{ zIndex: "owned", cursor: "pointer" }}
        >
          <div className="box">
            <img
              src={
                entity_type === "material" 
                  ? getThumbnail()
                  : ele.thumbnail
                    ? getThumbnail()
                    : entityType == "product"
                      ? require("../../../../assets/images/chair.png")
                      : require("../../../../assets/images/scene_incomplete.svg")
              }
              style={{ objectFit: "contain", width: "100%", height: 260 }}
            />
          </div>
          <div style={{ margin: "2px 10px 0px 10px" }}>
            <div className="tag-section">
              <div className={`tag scene-tag`}>
                <span>Material</span>
              </div>
              <div className={`tag ${updateTime == "Today" && "today-tag"}`}>
                <ClockCircleOutlined />
                <span className="ml-4">{updateTime}</span>
              </div>
            </div>
            {
              artistSearch ? <div className="entity-name">
              <Tooltip title={ele.id}>
                <span className="manrope f-14 w-500 card-name">
                  {ele.id}
                </span>
              </Tooltip>
            </div>
            :
            <div className="entity-name">
              <Tooltip title={ele.name}>
                <span className="manrope f-14 w-500 card-name">
                  {selectable
                    ? entity_type == "room"
                      ? ele.room_name
                      : ele.name
                    : ele.name}
                </span>
              </Tooltip>
            </div>
            }
            <div className="ml-8 mb-4">
              <div>
                <span className="manrope f-14 w-500 lh-28 black-73 white-space-text">
                  Category
                </span>
                <span className="manrope f-14 w-500 black-d9 ml-8">
                  {ele.category || "N/A"}
                </span>
              </div>
              {
                !artistSearch &&
                <div>
                <span className="manrope f-14 w-500 lh-28 black-73 white-space-text">
                  Item ID
                </span>
                <span className="manrope f-14 w-500 black-d9 ml-8">
                  {ele.brand_id || "N/A"}
                </span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default EntityItem;
